/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrInviteBody
 */
export interface RttrInviteBody {
    /**
     * 
     * @type {string}
     * @memberof RttrInviteBody
     */
    recipientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof RttrInviteBody
     */
    recipientLastName: string;
    /**
     * 
     * @type {string}
     * @memberof RttrInviteBody
     */
    recipientEmail: string;
    /**
     * Inviter-entered "From" name used as the email's sender identity.
     * @type {string}
     * @memberof RttrInviteBody
     */
    fromName: string;
}

/**
 * Check if a given object implements the RttrInviteBody interface.
 */
export function instanceOfRttrInviteBody(value: object): value is RttrInviteBody {
    if (!('recipientFirstName' in value) || value['recipientFirstName'] === undefined) return false;
    if (!('recipientLastName' in value) || value['recipientLastName'] === undefined) return false;
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    if (!('fromName' in value) || value['fromName'] === undefined) return false;
    return true;
}

export function RttrInviteBodyFromJSON(json: any): RttrInviteBody {
    return RttrInviteBodyFromJSONTyped(json, false);
}

export function RttrInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientFirstName': json['recipientFirstName'],
        'recipientLastName': json['recipientLastName'],
        'recipientEmail': json['recipientEmail'],
        'fromName': json['fromName'],
    };
}

export function RttrInviteBodyToJSON(json: any): RttrInviteBody {
    return RttrInviteBodyToJSONTyped(json, false);
}

export function RttrInviteBodyToJSONTyped(value?: RttrInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientFirstName': value['recipientFirstName'],
        'recipientLastName': value['recipientLastName'],
        'recipientEmail': value['recipientEmail'],
        'fromName': value['fromName'],
    };
}

